export const ProductData = {
  subtitle: "Sneaker Company",
  title: "Fall Limited Edition Sneakers",
  description:
    "These low-profile sneakers are your perfect casual wear companion. Featuring a durable rubber outlet sole, they'll withstand everything the weather can offer.",
  price: 125.00,
};
